import {
  Component,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
// Services
import { SharedService } from 'src/app/shared/services/shared.service';
import { ModalID, signatureType } from '../../models/constants';
import { CapturedSignature } from '../../models/general';

@Component({
    selector: 'app-digital-signature',
    templateUrl: './digital-signature.component.html',
    styleUrls: ['./digital-signature.component.scss'],
    standalone: true,
    imports: []
})
export class DigitalSignatureComponent implements AfterViewInit {
  @ViewChild('signaturePad') signaturePad: ElementRef;
  private context: CanvasRenderingContext2D;
  private isDrawing = false;
  signature_type: string
  header: string | null = null;

  constructor(private sharedService: SharedService, private el: ElementRef) {}
  private highlight(color: string) {
    this.signaturePad.nativeElement.style.borderColor = color;
    if (color === 'green') {
      this.signaturePad.nativeElement.style.boxShadow = '0 0 10px green';
    } else {
      this.signaturePad.nativeElement.style.boxShadow = 'none';
    }
  }

  ngAfterViewInit() {
    this.context = this.signaturePad.nativeElement.getContext('2d');
    this.context.strokeStyle = 'black'; // Set stroke color
    this.context.lineWidth = 2; // Set stroke width
    this.signaturePad.nativeElement.addEventListener('mousedown', (e) =>
      this.startDrawing(e)
    );
    this.signaturePad.nativeElement.addEventListener('mousemove', (e) =>
      this.draw(e)
    );
    this.signaturePad.nativeElement.addEventListener('mouseup', () =>
      this.stopDrawing()
    );
    this.signaturePad.nativeElement.addEventListener('mouseenter', () =>
      this.highlight('green')
    );
    this.signaturePad.nativeElement.addEventListener('mouseleave', () =>
      this.highlight(null)
    );
    if (signatureType.find(s => s.name === this.signature_type)?.alias) {
      this.header = signatureType.find(s => s.name === this.signature_type)?.alias
    }
  }
  private getEventCoordinates(event: MouseEvent): { x: number; y: number } {
    const rect = this.signaturePad.nativeElement.getBoundingClientRect();
    return {
      x: event.clientX - rect.left,
      y: event.clientY - rect.top,
    };
  }
  startDrawing(e: MouseEvent) {
    this.isDrawing = true;
    const { x, y } = this.getEventCoordinates(e);
    this.context.beginPath();
    this.context.moveTo(x, y);
  }
  draw(e: MouseEvent) {
    if (!this.isDrawing) return;
    const { x, y } = this.getEventCoordinates(e);
    this.context.lineTo(x, y);
    this.context.stroke();
    this.context.beginPath();
    this.context.moveTo(x, y);
  }
  stopDrawing() {
    this.isDrawing = false;
    this.context.stroke();
  }
  clear() {
    this.context.clearRect(
      0,
      0,
      this.signaturePad.nativeElement.width,
      this.signaturePad.nativeElement.height
    );
  }
  save() {
  const signature_data: CapturedSignature = {
    signature_type: this.signature_type,
    signature: this.signaturePad.nativeElement.toDataURL('image/png')
  };
  
  this.sharedService.signatureCaptured$.next(signature_data);
  this.sharedService.closeModal(ModalID.digital_signature);
}
  closeModalClick() {
    this.sharedService.closeModal(ModalID.digital_signature);
  }
}
